import { Component, OnInit, Input } from '@angular/core';
import { RecoveryVendorCredentials, Licensing } from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-repossession',
  templateUrl: './state-requirement-repossession.component.html',
  styleUrls: ['./state-requirement-repossession.component.css']
})
export class StateRequirementRepossessionComponent implements OnInit {
  public role : string;
  public showFlag: boolean = false;
  public parClicked: any;
  public agentClicked: any;
  constructor() {
    
    this._repossessionAgent = new RecoveryVendorCredentials();
  }

  private _repossessionAgent: RecoveryVendorCredentials;
  public get repossessionAgent(): RecoveryVendorCredentials {
    return this._repossessionAgent;
  }

  @Input()
  public set repossessionAgent(value: RecoveryVendorCredentials) {
    if (typeof value !== 'undefined' && value !== null) {
    this._repossessionAgent = value;
    }
    else{
      this._repossessionAgent = new RecoveryVendorCredentials();
    }
  }
  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if(this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")){
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else
    {
      this.showFlag = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-repossession/state-requirement-repossession.component.ts